// constants/commissariatPolitiqueData.ts
// Données complètes du commissariat politique UDB

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GABON_GEOGRAPHIC_DATA } from './gabonGeographicData';

// ==========================================
// INTERFACES ET TYPES
// ==========================================

export interface CommissaireData {
    name: string;
    position?: string;
    isWoman?: boolean; // Pour statistiques genre
}

export interface Canton {
    name: string;
    commissaires: CommissaireData[];
}

export interface Arrondissement {
    name: string;
    commissaires: CommissaireData[];
    cantons?: Canton[];
}

export interface Commune {
    name: string;
    arrondissements?: Arrondissement[];
    commissaires?: CommissaireData[];
    cantons?: Canton[];
}

export interface Departement {
    name: string;
    code: string;
    ville?: string;
    commissairesDepartementaux: CommissaireData[];
    commissairesCommunaux?: CommissaireData[];
    communes?: Commune[];
    cantons?: Canton[];
}

export interface ProvinceCommissariat {
    id: string;
    name: string;
    code: string;
    departements: Departement[];
    totalCommissaires: number;
    totalWomen: number;
    color: string;
    bgColor: string;
    textColor: string;
}

// ==========================================
// DONNÉES DU COMMISSARIAT POLITIQUE UDB
// ==========================================

export const COMMISSARIAT_POLITIQUE_DATA: ProvinceCommissariat[] = [
    // G1 - PROVINCE DE L'ESTUAIRE
    {
        id: 'G1',
        name: 'Estuaire',
        code: 'G1',
        color: 'primary-blue',
        bgColor: 'bg-primary-blue',
        textColor: 'text-primary-blue',
        totalCommissaires: 89,
        totalWomen: 23,
        departements: [
            {
                name: 'Commune de Libreville',
                code: 'LBV',
                commissairesDepartementaux: [],
                communes: [
                    {
                        name: 'Libreville',
                        arrondissements: [
                            {
                                name: '1er arrondissement',
                                commissaires: [
                                    { name: 'Nicolas NGUEMA' },
                                    { name: 'Romuald ENGO NGUEMA' },
                                    { name: 'Ysaura Alicia NGARI', isWoman: true },
                                    { name: 'Nyl MORET MBA' },
                                    { name: 'Eolia Mandie ADIAHENO', isWoman: true },
                                    { name: 'Alban Stéphane OSSINGA ONANGA' },
                                    { name: 'Stephen Darel SOWA AKENDENGUE' }
                                ]
                            },
                            {
                                name: '2e arrondissement',
                                commissaires: [
                                    { name: 'Aurelien NTOUTOUME' },
                                    { name: 'Chrystelle EYEGHE', isWoman: true },
                                    { name: 'Innocent OVONO EYI' },
                                    { name: 'Eric MEBIAME ME NDONG' },
                                    { name: 'Léandre ZUE' }
                                ]
                            },
                            {
                                name: '3e arrondissement',
                                commissaires: [
                                    { name: 'Sylvie KOTHA eps NZAMBA', isWoman: true },
                                    { name: 'Melvin GONDJOUT' },
                                    { name: 'Alex CEDRIC ANGUILET' },
                                    { name: 'Christiane MARAT GNANGUE', isWoman: true },
                                    { name: 'Franck IBOUILY' },
                                    { name: 'Edwige Pulchérie ANDEME OBAME', isWoman: true },
                                    { name: 'Serges William AKASSAGA' }
                                ]
                            },
                            {
                                name: '4e arrondissement',
                                commissaires: [
                                    { name: 'Severin Pierre NDONG EKOMI' },
                                    { name: 'Alain Pierre ADJEMBIMANDE SAJOUX' },
                                    { name: 'Franck ENEME' },
                                    { name: 'Isabelle BEKALE', isWoman: true },
                                    { name: 'Amable Aurelien MEYEKET LIN' }
                                ]
                            },
                            {
                                name: '5e arrondissement',
                                commissaires: [
                                    { name: 'Ismaela PIRA Epse OURAP', isWoman: true },
                                    { name: 'Pierre NGOME AYONG' },
                                    { name: 'Lénine NDJEMBI MAGOSSO' },
                                    { name: 'Ulfrid AGAYA' }
                                ]
                            },
                            {
                                name: '6e arrondissement',
                                commissaires: [
                                    { name: 'Karl Ulrich BIWAGO' },
                                    { name: 'Ralph AIME ISSISSAH' },
                                    { name: 'Daniel NKOULOU ABESSOLO' },
                                    { name: 'Juvénal Roblex ONDO' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Commune d\'Akanda',
                code: 'AKD',
                commissairesDepartementaux: [],
                communes: [
                    {
                        name: 'Akanda',
                        arrondissements: [
                            {
                                name: '1er arrondissement',
                                commissaires: [
                                    { name: 'Philippe Léon AUGE' },
                                    { name: 'Pascal MBA SIMA' },
                                    { name: 'Yves ANDEKO' },
                                    { name: 'Erick EKOMBA' }
                                ]
                            },
                            {
                                name: '2e arrondissement',
                                commissaires: [
                                    { name: 'Christiane EBANG ASSEKO', isWoman: true },
                                    { name: 'Steeve ISSEMBE NDAMBO' },
                                    { name: 'Joséphine Naida MALIBALA ANGUE', isWoman: true },
                                    { name: 'Franck NZE NDONG NZE' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Commune d\'Owendo',
                code: 'OWD',
                commissairesDepartementaux: [],
                communes: [
                    {
                        name: 'Owendo',
                        arrondissements: [
                            {
                                name: '1er arrondissement',
                                commissaires: [
                                    { name: 'Eric BOUMAH' },
                                    { name: 'Davy YAKOMA' },
                                    { name: 'Roland MBADINGA' },
                                    { name: 'Eva Coralie MOULE', isWoman: true },
                                    { name: 'Claude Bernard NTOUGOU' },
                                    { name: 'Jean Jacques MOMBO' }
                                ]
                            },
                            {
                                name: '2e arrondissement',
                                commissaires: [
                                    { name: 'Julien ATEBA EDOU' },
                                    { name: 'Abraham OTOUNGA' },
                                    { name: 'Christiian MOMBO MAGANGA' },
                                    { name: 'Hugues Régis MAYOMBO' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Commune de Ntoum',
                code: 'NTM',
                commissairesDepartementaux: [],
                communes: [
                    {
                        name: 'Ntoum',
                        arrondissements: [
                            {
                                name: '1er arrondissement',
                                commissaires: [
                                    { name: 'Sylvère NTOUTOUME ONGONE' },
                                    { name: 'Jean Benoit MAKOUNDI' },
                                    { name: 'Christelle EYANG', isWoman: true },
                                    { name: 'Eric ABOGHE NZET' }
                                ]
                            },
                            {
                                name: '2e arrondissement',
                                commissaires: [
                                    { name: 'Joséphine ANDEME MANFOUMBI', isWoman: true },
                                    { name: 'Judicael MAMBOUNDOU' },
                                    { name: 'Aloise BEKALE NTOUTOUME' }
                                ]
                            },
                            {
                                name: '3e arrondissement',
                                commissaires: [
                                    { name: 'Suzy Dorelle MATOUMBA Epse MOMBO', isWoman: true },
                                    { name: 'Paul Yannick BITOME' },
                                    { name: 'Mihindou MBOUMBOU Claude Patrice' },
                                    { name: 'Aimé -fiacre PITHA' },
                                    { name: 'Paulin Mickael MBA BYOGHE' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Département Komo-Mondah',
                code: 'KMD',
                ville: 'Ntoum',
                commissairesDepartementaux: [
                    { name: 'NDJOUMBI Phillipe' },
                    { name: 'Hervé NNANGUE ENGUE' },
                    { name: 'Hans MESSANI NTOUTOUME' },
                    { name: 'Aristide NZUE NTOUTOUME' },
                    { name: 'Jean de Dieu NZUE NDONG INYNGOUE' }
                ]
            },
            {
                name: 'Département Komo Océan',
                code: 'KOC',
                ville: 'Ndzomoe',
                commissairesDepartementaux: [
                    { name: 'Mirabelle NGNIGONE', isWoman: true },
                    { name: 'Pierre NDON NZOGHE' },
                    { name: 'Jean-jacques NDONG EKOUGHE' }
                ]
            },
            {
                name: 'Département Komo (Kango)',
                code: 'KMO',
                ville: 'Kango',
                commissairesDepartementaux: [
                    { name: 'Jacques MINKO MI ANGOUE' },
                    { name: 'Jean EYENE BEKALA' },
                    { name: 'Narcisse OBIANG ONDO' },
                    { name: 'Alain Valery Burobu Bu BUSSA' },
                    { name: 'Melùca Rufin NZAOU NZAOU' },
                    { name: 'Pierre NZIENGUI MOUELE' }
                ],
                commissairesCommunaux: [
                    { name: 'NANG OBIANG Paul' },
                    { name: 'Jacques MINKO MI ANGOUE' },
                    { name: 'Jean-Claude NDONG MBA' },
                    { name: 'Alain Christian KOUMBA' },
                    { name: 'Henri BEKALE AKWE' }
                ]
            },
            {
                name: 'Département de la Noya (Cocobeach)',
                code: 'NYA',
                ville: 'Cocobeach',
                commissairesDepartementaux: [
                    { name: 'Edwidge OSSOMANE', isWoman: true },
                    { name: 'Pierre MBENG EYENE' }
                ],
                commissairesCommunaux: [
                    { name: 'Melissa NTOUMTOUM', isWoman: true },
                    { name: 'Saint Paul NZOGHE DE NZOGHE' }
                ]
            }
        ]
    },

    // G2 - PROVINCE DU HAUT-OGOOUÉ
    {
        id: 'G2',
        name: 'Haut-Ogooué',
        code: 'G2',
        color: 'primary-green',
        bgColor: 'bg-primary-green',
        textColor: 'text-primary-green',
        totalCommissaires: 112,
        totalWomen: 18,
        departements: [
            {
                name: 'Département de la Mpassa (Franceville)',
                code: 'MPS',
                ville: 'Franceville',
                commissairesDepartementaux: [
                    { name: 'Florence MBANI', isWoman: true },
                    { name: 'Lucien EPIMI GUIA' },
                    { name: 'Abel NDJINGA' },
                    { name: 'Jean Sylvain MANDZA' },
                    { name: 'Jean bernard NGALEBIKA' }
                ],
                communes: [
                    {
                        name: 'Franceville',
                        arrondissements: [
                            {
                                name: '1er arrondissement',
                                commissaires: [
                                    { name: 'Malibala EDGARD PROSPERO' },
                                    { name: 'KOUMBA TIBAULT' },
                                    { name: 'Herve ONKOUKOUSSOU' },
                                    { name: 'Jean Paul MFOUBA' }
                                ]
                            },
                            {
                                name: '2e arrondissement',
                                commissaires: [
                                    { name: 'Ismael LIBIZANGO' },
                                    { name: 'Romaric ALOUBANGOYE' },
                                    { name: 'Justin NDOUDANGOYE' },
                                    { name: 'Jean Francis EKIBA' }
                                ]
                            },
                            {
                                name: '3e arrondissement',
                                commissaires: [
                                    { name: 'Mathurin LEHOUMBOUL' },
                                    { name: 'Luther Steeven ABOUNA' }
                                ]
                            },
                            {
                                name: '4e arrondissement',
                                commissaires: [
                                    { name: 'Jean Lucien DOUMBOUNENI' },
                                    { name: 'Anselme LIBAMA' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Département de la Bayi-Brikolo (Aboumi)',
                code: 'BBR',
                ville: 'Aboumi',
                commissairesDepartementaux: [
                    { name: 'Hervé Davy LETSINA OYOUMI' },
                    { name: 'Errnaud Bechanel AYEBE MICKALA' }
                ],
                commissairesCommunaux: [
                    { name: 'Jean Bosco NDJOUNGA' },
                    { name: 'Jean Félix ONKEYA' }
                ]
            },
            {
                name: 'Département de l\'Ogooué-Letili (Boumango)',
                code: 'OLT',
                ville: 'Boumango',
                commissairesDepartementaux: [
                    { name: 'Alain Gualbert MAÏSSA' }
                ],
                commissairesCommunaux: [
                    { name: 'Marie Yolande MISSIE', isWoman: true }
                ]
            },
            {
                name: 'Département des Plateaux (Léconi)',
                code: 'PLT',
                ville: 'Léconi',
                commissairesDepartementaux: [
                    { name: 'Gilbert NGOMBI' },
                    { name: 'Jean BONGO' },
                    { name: 'Jacques KAMFOUGA' }
                ],
                commissairesCommunaux: [
                    { name: 'Jean Paul NKIRI' },
                    { name: 'Nathalie NTHE', isWoman: true }
                ]
            },
            {
                name: 'Département de la Lekoni-Lekori (Akiéni)',
                code: 'LLK',
                ville: 'Akiéni',
                commissairesDepartementaux: [
                    { name: 'Guy KABONGO ABDUL RAZZAQ' },
                    { name: 'Sylvain ENKORO' }
                ],
                commissairesCommunaux: [
                    { name: 'Frifolin ONGUINDANDJONA Cyriaque' },
                    { name: 'Dieudonné EGNINA NDOMBI' },
                    { name: 'Thierry OYANINGUI' }
                ]
            },
            {
                name: 'Département de la Lekabi-Lewolo (Ngouoni)',
                code: 'LLW',
                ville: 'Ngouoni',
                commissairesDepartementaux: [
                    { name: 'Alice NGOUNGOULOU', isWoman: true },
                    { name: 'Dieudonné OBISSA' },
                    { name: 'Sosthène AGNOUGA' },
                    { name: 'Alfred NGUIA BANDA' }
                ],
                commissairesCommunaux: [
                    { name: 'Moustapha NGARI' },
                    { name: 'Damas KAKOUNDJA' },
                    { name: 'Ferdin LEMAMI' }
                ]
            },
            {
                name: 'Département de la Djouori-Agnili (Bongoville)',
                code: 'DJA',
                ville: 'Bongoville',
                commissairesDepartementaux: [
                    { name: 'Mohamed OMBIGATH' },
                    { name: 'Alix Bertille SOUGOUSIRE LOOCKMAN OMPATHA GABIRA', isWoman: true },
                    { name: 'Hugues Modeste ODJANGOU' }
                ],
                commissairesCommunaux: [
                    { name: 'OBAGUI MPIGA Jenny', isWoman: true },
                    { name: 'Bob MPILI YAO' },
                    { name: 'Saturnin ODOUMA' },
                    { name: 'Rodrigue BONGO' },
                    { name: 'Prisca OPIRINA', isWoman: true }
                ]
            },
            {
                name: 'Département de Sebé-Bricolo (Okondja)',
                code: 'SBR',
                ville: 'Okondja',
                commissairesDepartementaux: [
                    { name: 'Max Samuel OBOUMANDJOGHO' },
                    { name: 'Gael OKINKALI' },
                    { name: 'Eugenie ZIMA', isWoman: true },
                    { name: 'Pamphil EYOUGA' }
                ],
                commissairesCommunaux: [
                    { name: 'Brigitte ONKANOWA', isWoman: true },
                    { name: 'Gislain OTSOBI' },
                    { name: 'Duplex YOKOTI' },
                    { name: 'Igor ONTSIRIGA' }
                ]
            },
            {
                name: 'Département de la Lebombi-Leyou (Moanda)',
                code: 'LBL',
                ville: 'Moanda',
                commissairesDepartementaux: [
                    { name: 'Idris WANA' },
                    { name: 'Bertrand Rubens MATEYA' }
                ],
                commissairesCommunaux: [
                    { name: 'Teddy LOBA' },
                    { name: 'Merlin KETSABI' },
                    { name: 'Kevin MONDJO' },
                    { name: 'Junior ANNICET MANGOUMBA' },
                    { name: 'Armant Colbert LEBOMO' }
                ]
            },
            {
                name: 'Département de la Lekoko (Bakoumba)',
                code: 'LKK',
                ville: 'Bakoumba',
                commissairesDepartementaux: [
                    { name: 'Rock ATANA' },
                    { name: 'Antoine LEYOGHO' }
                ],
                commissairesCommunaux: [
                    { name: 'Gilles Toussaint NEMBE' },
                    { name: 'Asther MAFANGA', isWoman: true },
                    { name: 'Noël MIKENDA' }
                ]
            },
            {
                name: 'Commune de Mounana',
                code: 'MNN',
                commissairesDepartementaux: [],
                commissairesCommunaux: [
                    { name: 'Linis Francis LENDJOUNGOU' },
                    { name: 'Cédrick MAKA TONGO' },
                    { name: 'Fabrice Ulrich MOUANDZOUDI' }
                ]
            },
            {
                name: 'Département de la Djoué (Onga)',
                code: 'DJU',
                ville: 'Onga',
                commissairesDepartementaux: [
                    { name: 'Platini ASSARI DE NDOUNA' }
                ],
                commissairesCommunaux: [
                    { name: 'Omar Roberson MVOUO' }
                ]
            }
        ]
    },

    // G3 - PROVINCE DU MOYEN-OGOOUÉ
    {
        id: 'G3',
        name: 'Moyen-Ogooué',
        code: 'G3',
        color: 'primary-yellow',
        bgColor: 'bg-primary-yellow',
        textColor: 'text-primary-yellow',
        totalCommissaires: 37,
        totalWomen: 8,
        departements: [
            {
                name: 'Commune de Lambaréné',
                code: 'LBR',
                commissairesDepartementaux: [],
                commissairesCommunaux: [
                    { name: 'Jose FOULA WALTER' },
                    { name: 'Guy Pierre BITEGHE' },
                    { name: 'Giscard lilian OGOULA' },
                    { name: 'Félicité ESSOUE', isWoman: true },
                    { name: 'Christian NGONDA' },
                    { name: 'Phillipe MEDOUA NZE' },
                    { name: 'Bernard OSSAVOU' },
                    { name: 'Landry NKEYI' },
                    { name: 'Victorine KOUNDI', isWoman: true },
                    { name: 'Maurice TSOUMBO' }
                ]
            },
            {
                name: 'Département de l\'Ogooué et les Lacs',
                code: 'OGL',
                ville: 'Lambaréné',
                commissairesDepartementaux: [
                    { name: 'Angelique KOMBILA', isWoman: true },
                    { name: 'Valéry AMBONGUILA' },
                    { name: 'Jean Pierre ROUGOU' },
                    { name: 'Darcy ONANGA' },
                    { name: 'Franklyn MBA' },
                    { name: 'Brigitte OSSAKEDJOMBO-KAACK', isWoman: true },
                    { name: 'Didier NDONG' },
                    { name: 'Clotilde BIANG NZE', isWoman: true }
                ]
            },
            {
                name: 'Département de l\'Abanga Bigne (Njole)',
                code: 'ABG',
                ville: 'Njole',
                commissairesDepartementaux: [
                    { name: 'Régis Emane' },
                    { name: 'Régis Émane BIFOUN' },
                    { name: 'Thomas NZOME' },
                    { name: 'Marc Edgard Fernandez NSOLE EDOU' },
                    { name: 'Jean Barthelemy OBAME EVOUNGHA' }
                ],
                commissairesCommunaux: [
                    { name: 'Yolande NZAME', isWoman: true },
                    { name: 'Carine NZE MELIGHE', isWoman: true },
                    { name: 'Daltry N\'NANG EKO' },
                    { name: 'Patrick ACKAME' },
                    { name: 'Mane BEKALE' },
                    { name: 'Jovani EYENGA' }
                ]
            }
        ]
    },

    // G4 - PROVINCE DE LA NGOUNIÉ
    {
        id: 'G4',
        name: 'Ngounié',
        code: 'G4',
        color: 'primary-blue',
        bgColor: 'bg-primary-blue',
        textColor: 'text-primary-blue',
        totalCommissaires: 52,
        totalWomen: 15,
        departements: [
            {
                name: 'Commune de Mouila',
                code: 'MLA',
                commissairesDepartementaux: [],
                commissairesCommunaux: [
                    { name: 'Berenger MOUSSAVOU' },
                    { name: 'Armand Juldas MBADINGA' }
                ]
            },
            {
                name: 'Département de la Douya-Onoye',
                code: 'DOY',
                ville: 'Mouila',
                commissairesDepartementaux: [
                    { name: 'Yvon Patrick NDINGA' },
                    { name: 'Cunégonde MAHOUDA', isWoman: true },
                    { name: 'Cyr BIGOUNDOU' }
                ]
            },
            {
                name: 'Département de la Dola',
                code: 'DOL',
                ville: 'Ndendé',
                commissairesDepartementaux: [
                    { name: 'Mourela BIGOUAGOU BIGOUAGOU' },
                    { name: 'Rosette KOUMBA', isWoman: true },
                    { name: 'Paul Timothé II MBOUBA' }
                ],
                commissairesCommunaux: [
                    { name: 'Adelaide MOUSSAVOU', isWoman: true },
                    { name: 'Gisèle ITOUMBA', isWoman: true },
                    { name: 'Loic NDINGA MOUDOUMA' },
                    { name: 'Cyr Symphorien MOUKAGA' }
                ]
            },
            {
                name: 'Département de la Louesti-Wano',
                code: 'LWN',
                ville: 'Lébamba',
                commissairesDepartementaux: [
                    { name: 'Lambert IDODO' }
                ],
                commissairesCommunaux: [
                    { name: 'Guy Florent NDONGO' }
                ]
            },
            {
                name: 'Département de la Boumi-Louesti (Mbigou)',
                code: 'BML',
                ville: 'Mbigou',
                commissairesDepartementaux: [
                    { name: 'Cyriaque MOUKOUNDJI' },
                    { name: 'Adrien MOUGOUGOU' }
                ],
                commissairesCommunaux: [
                    { name: 'Dr Andy Gregory LEYOUDA BIKOTA' },
                    { name: 'Saint Aymar Lhyé BUKWANGUI' }
                ]
            },
            {
                name: 'Département de l\'Ogoulou (Mimongo)',
                code: 'OGL',
                ville: 'Mimongo',
                commissairesDepartementaux: [
                    { name: 'Pacôme Modeste IDIATHA NGUIMBI' },
                    { name: 'Cyrille Severin BUSSIENGOU' }
                ],
                commissairesCommunaux: [
                    { name: 'Luc BOUYELA' },
                    { name: 'Lezin Gustave BOUKANDJA' }
                ]
            },
            {
                name: 'Département de Ndolou (Mandji)',
                code: 'NDL',
                ville: 'Mandji',
                commissairesDepartementaux: [
                    { name: 'Maryse MATSANGA MAYILA épouse ISSIEMOU', isWoman: true }
                ],
                commissairesCommunaux: [
                    { name: 'Thierry Martial MOUBOKOUNOU' }
                ]
            },
            {
                name: 'Département de Tsamba-Magotsi (Fougoumou)',
                code: 'TMG',
                ville: 'Fougoumou',
                commissairesDepartementaux: [
                    { name: 'Joseph MOUTANDOU MBOUMBA' },
                    { name: 'Dieudonné Claude DIBADY MAYILA' }
                ],
                commissairesCommunaux: [
                    { name: 'Jean-François KOUANGA' }
                ]
            },
            {
                name: 'Département Louetsi-Bibaka',
                code: 'LBK',
                ville: 'Malinga',
                commissairesDepartementaux: [
                    { name: 'Jean-François KOUANGA' }
                ],
                commissairesCommunaux: [
                    { name: 'Guy Fulbert MABENGHA' }
                ]
            },
            {
                name: 'Département de Mougalaba',
                code: 'MGB',
                ville: 'Guiétsou',
                commissairesDepartementaux: [
                    { name: 'Roland MATSIENDI' },
                    { name: 'PIE MAKANGA MISSAMOU' }
                ],
                commissairesCommunaux: [
                    { name: 'Kevine MBADINGA', isWoman: true },
                    { name: 'Aubierge MOUSSAVOU Epse IGOUWE', isWoman: true },
                    { name: 'Christian MABOUNDA MOUENDOU' }
                ]
            }
        ]
    },

    // G5 - PROVINCE DE LA NYANGA
    {
        id: 'G5',
        name: 'Nyanga',
        code: 'G5',
        color: 'primary-green',
        bgColor: 'bg-primary-green',
        textColor: 'text-primary-green',
        totalCommissaires: 68,
        totalWomen: 17,
        departements: [
            {
                name: 'Commune de Tchibanga',
                code: 'TCH',
                commissairesDepartementaux: [],
                commissairesCommunaux: [
                    { name: 'Pierre Alain MOUNGUENGUI' },
                    { name: 'Lucien Steevy MAVIOGA' },
                    { name: 'Guy roger KOMBILA MOUNDOUNGA' },
                    { name: 'Yves Sylvain MOUSSAVOU' },
                    { name: 'Staël BOUTAMBA' },
                    { name: 'Brice Didier KOUMBA MABERT' },
                    { name: 'Yolande IBINGA épouse KOUMBA', isWoman: true },
                    { name: 'Rodrigue MACKAYA' },
                    { name: 'Ermine Marie Emilie DOUTSONA Epse MANFOUMBI', isWoman: true },
                    { name: 'Ginette Flore MACKOSSO', isWoman: true }
                ]
            },
            {
                name: 'Département de Mougoutsi',
                code: 'MGT',
                ville: 'Tchibanga',
                commissairesDepartementaux: [
                    { name: 'Gauthier MIHINDOU MBINA' },
                    { name: 'Sylvain IBOUANGA MBOUMBA' },
                    { name: 'Délphine PAMBOU', isWoman: true },
                    { name: 'Léonce BOULINGUI' },
                    { name: 'Gislaine MILEBOU', isWoman: true }
                ]
            },
            {
                name: 'Département de la Basse-Banio (Mayumba)',
                code: 'BBN',
                ville: 'Mayumba',
                commissairesDepartementaux: [
                    { name: 'Flatteli Martial FOUTY' },
                    { name: 'Lionel Armel MAVOUNGO' },
                    { name: 'Etienne NGOUBOU' }
                ],
                commissairesCommunaux: [
                    { name: 'Paul KOUMBA NZAOU' },
                    { name: 'Chaning Zenaba GNINGA', isWoman: true },
                    { name: 'Jeff OKOKA' },
                    { name: 'Jean Félicien MAKANGA' }
                ]
            },
            {
                name: 'Département de la Haute-Banio (Ndindi)',
                code: 'HBN',
                ville: 'Ndindi',
                commissairesDepartementaux: [
                    { name: 'Prosper NDJIMBI MACKOSSO' },
                    { name: 'Jeannine SITOU', isWoman: true }
                ],
                commissairesCommunaux: [
                    { name: 'Régis MBOUMBOU' },
                    { name: 'Guy Martial MACKOSSO' }
                ]
            },
            {
                name: 'Département de la Douigny (Moabi)',
                code: 'DGY',
                ville: 'Moabi',
                commissairesDepartementaux: [
                    { name: 'Jean MBADINGA MBADINGA' },
                    { name: 'Edgard MBINA KOMBILA' },
                    { name: 'Justin MAGANGA MANFOUMBI' },
                    { name: 'Walice Daria MASSOUNGA DOUKAGA', isWoman: true }
                ],
                commissairesCommunaux: [
                    { name: 'Judith BOUASSA', isWoman: true },
                    { name: 'Bonaventure NZIGOU MANFOUMBI' },
                    { name: 'Delphin KOMBILA KOMBILA' }
                ]
            },
            {
                name: 'Département de la Doutsila',
                code: 'DTS',
                ville: 'Mabanda',
                commissairesDepartementaux: [
                    { name: 'Charles Edgar MOMBO' },
                    { name: 'Guy Patrick MBOUMBA MIHINDOU' },
                    { name: 'Yves Mesmin MBADINGA' },
                    { name: 'Jonas IBIATSI MABICKA' }
                ],
                commissairesCommunaux: [
                    { name: 'Guy Patrick MBOUMBA MIHINDOU' },
                    { name: 'Issa MBADINGA' },
                    { name: 'Jonas IBIATSI MABICKA' },
                    { name: 'Yves Mesmin MBADINGA' }
                ]
            },
            {
                name: 'Département de Mongo',
                code: 'MNG',
                ville: 'Moulengui-Binza',
                commissairesDepartementaux: [
                    { name: 'Jovin MABIALA' },
                    { name: 'Gildas Brice DIVINA' }
                ],
                commissairesCommunaux: [
                    { name: 'Nani YEMBI', isWoman: true }
                ]
            },
            {
                name: 'Département de Moulengui-Binza',
                code: 'MLB',
                ville: 'Moulengui-Binza',
                commissairesDepartementaux: [
                    { name: 'Jovin MABIALA' },
                    { name: 'Gildas Brice DIVINA' }
                ],
                commissairesCommunaux: [
                    { name: 'Nani YEMBI', isWoman: true }
                ]
            }
        ]
    },

    // G6 - PROVINCE DE L'OGOOUÉ-IVINDO
    {
        id: 'G6',
        name: 'Ogooué-Ivindo',
        code: 'G6',
        color: 'primary-yellow',
        bgColor: 'bg-primary-yellow',
        textColor: 'text-primary-yellow',
        totalCommissaires: 28,
        totalWomen: 6,
        departements: [
            {
                name: 'Commune de Makokou',
                code: 'MKK',
                commissairesDepartementaux: [],
                commissairesCommunaux: [
                    { name: 'Jacquelin BEJITSI' },
                    { name: 'André NKOGHE ELLA' },
                    { name: 'Pamela Marylène BALAMY SINGATADY', isWoman: true },
                    { name: 'Judes NGWA EMANE' },
                    { name: 'Pamphile SANGOMA' },
                    { name: 'Ruphin Thérence MAHANDJI' }
                ]
            },
            {
                name: 'Département de l\'Ivindo',
                code: 'IVD',
                ville: 'Makokou',
                commissairesDepartementaux: [
                    { name: 'Raymond DJEMA' },
                    { name: 'Judes NGOUA EMANE' },
                    { name: 'Florent NZOME AFANE' },
                    { name: 'Virginie Valentine BEKOPA', isWoman: true },
                    { name: 'Blaise DJIDJI' },
                    { name: 'Claudine MENVOLE ME NZE Epse ADJEMBIMANDE', isWoman: true }
                ]
            },
            {
                name: 'Département de la Zadié',
                code: 'ZDI',
                ville: 'Mékambo',
                commissairesDepartementaux: [
                    { name: 'Guy serges AHOUNANDO' },
                    { name: 'Fiacre MPAKO NGOMA' },
                    { name: 'Alexandre ILONGO ADAMOU' },
                    { name: 'Barry NDIMAL' }
                ],
                commissairesCommunaux: [
                    { name: 'Franck ATABI BOKAMBA NDOMBI' },
                    { name: 'Castin LOMBALI' },
                    { name: 'BADIGeorges christian WAZA' }
                ]
            },
            {
                name: 'Département de la Lopé (Booué)',
                code: 'LPE',
                ville: 'Booué',
                commissairesDepartementaux: [
                    { name: 'Daniel MINKO' },
                    { name: 'Patrick NDONG' }
                ],
                commissairesCommunaux: [
                    { name: 'Franck MINDOUMBI' },
                    { name: 'Raphael NGAZOUZET' },
                    { name: 'airou MAMBOUZA WAGHE' }
                ]
            },
            {
                name: 'Département de la Mvoung (Ovan)',
                code: 'MVG',
                ville: 'Ovan',
                commissairesDepartementaux: [
                    { name: 'Narcisse MENDOUNG' },
                    { name: 'Clément BITEGHE' }
                ],
                commissairesCommunaux: [
                    { name: 'Chantal MEBALEY ABENDANG', isWoman: true }
                ]
            }
        ]
    },

    // G7 - PROVINCE DE L'OGOOUÉ-LOLO
    {
        id: 'G7',
        name: 'Ogooué-Lolo',
        code: 'G7',
        color: 'primary-blue',
        bgColor: 'bg-primary-blue',
        textColor: 'text-primary-blue',
        totalCommissaires: 40,
        totalWomen: 7,
        departements: [
            {
                name: 'Commune de Koulamoutou',
                code: 'KLM',
                commissairesDepartementaux: [],
                commissairesCommunaux: [
                    { name: 'Eric YOGHA YOGHA' },
                    { name: 'Alain Patrick LINDANDJI BIDONA' },
                    { name: 'Jean Hilarion LANDA' },
                    { name: 'Victor NGOUASSANGA' }
                ]
            },
            {
                name: 'Département de la Lolo-Bouenguidi',
                code: 'LBG',
                ville: 'Koulamoutou',
                commissairesDepartementaux: [
                    { name: 'Gustave MAYI' },
                    { name: 'Dr Silvere NGOUANDA MILLELLEY' },
                    { name: 'Georgette BANDONO Epse. SIMANGOYE', isWoman: true },
                    { name: 'Apolinaire IBAMBA' }
                ]
            },
            {
                name: 'Département de Mulundu (Lastoursville)',
                code: 'MLD',
                ville: 'Lastoursville',
                commissairesDepartementaux: [
                    { name: 'Gaetan IYEMBE' },
                    { name: 'Olga NGUIESSI', isWoman: true },
                    { name: 'Gael Rod NDJOYI KANDJOKO' },
                    { name: 'Patrice INGUILA' },
                    { name: 'Léa MBIDI MOUGHIGHOU', isWoman: true }
                ],
                commissairesCommunaux: [
                    { name: 'Brice PAILLAT' },
                    { name: 'BAKAKAS Bertrand' },
                    { name: 'Lucien BABALA NOYE' },
                    { name: 'Sylvain MAKOUMACHANA' }
                ]
            },
            {
                name: 'Département de la Lombo-Bouenguidi (Pana)',
                code: 'LMB',
                ville: 'Pana',
                commissairesDepartementaux: [
                    { name: 'Anselme KOUAMBA' },
                    { name: 'Jean francois mouwaka ngonga' },
                    { name: 'Arcadie Svetlana MINGUENGI Epse. NZOMA', isWoman: true }
                ],
                commissairesCommunaux: [
                    { name: 'BOUNBINDJI NZOBABA Armel' }
                ]
            },
            {
                name: 'Département de l\'Offoué-Onoye (Iboundji)',
                code: 'OFO',
                ville: 'Iboundji',
                commissairesDepartementaux: [
                    { name: 'Dominique NGUIENO' },
                    { name: 'Jean Claude PANGO' },
                    { name: 'Christ Leader MOUYIMBI' },
                    { name: 'Aimé MOUKAMBI BOMA' }
                ],
                commissairesCommunaux: [
                    { name: 'Marc Alexandre NDOUMBA' },
                    { name: 'Golda MBINGUI', isWoman: true },
                    { name: 'Ngachedi MONDJO' },
                    { name: 'J. Pierre BOUKILA' }
                ]
            }
        ]
    },

    // G8 - PROVINCE DE L'OGOOUÉ-MARITIME
    {
        id: 'G8',
        name: 'Ogooué-Maritime',
        code: 'G8',
        color: 'primary-green',
        bgColor: 'bg-primary-green',
        textColor: 'text-primary-green',
        totalCommissaires: 46,
        totalWomen: 9,
        departements: [
            {
                name: 'Commune de Port-Gentil',
                code: 'PG',
                commissairesDepartementaux: [],
                commissairesCommunaux: [
                    { name: 'Pascal HOUAGNI AMBOUROUET' },
                    { name: 'Ingrid LEYOUBOU SWAGATH', isWoman: true },
                    { name: 'Isaac BARBERA' },
                    { name: 'Eric AGONDJO' },
                    { name: 'Severin YABI' },
                    { name: 'Virginie WORA Epse ETENO', isWoman: true },
                    { name: 'Sophie ESSONGHE', isWoman: true },
                    { name: 'Boubacar NGOUWA GUINGO MAYAKI' },
                    { name: 'Richard ROYEMBO' },
                    { name: 'Landry MOUSSAMBI' },
                    { name: 'Jaures NDONG NZE' },
                    { name: 'Guy Roger AURAT' },
                    { name: 'Raphael RIYOGO' },
                    { name: 'Nicole NZAOU RECKATY', isWoman: true },
                    { name: 'Eric AYANG NANG' },
                    { name: 'Saturnin OBAME' }
                ]
            },
            {
                name: 'Département de Bendjé',
                code: 'BDJ',
                ville: 'Port-Gentil',
                commissairesDepartementaux: [
                    { name: 'Christan PEKOUE' },
                    { name: 'Jean Pierre MBADINGA NZAMBA' },
                    { name: 'Murielle BALLO', isWoman: true },
                    { name: 'Lucien MAYAGUI' },
                    { name: 'Stéphane ALIWA MBA' },
                    { name: 'Emile MOUDZIEGOU' }
                ]
            },
            {
                name: 'Département d\'Etimboue (Omboué)',
                code: 'ETM',
                ville: 'Omboué',
                commissairesDepartementaux: [
                    { name: 'ONANGA Georgina', isWoman: true },
                    { name: 'André AUGAND' },
                    { name: 'Hans OGOULA' }
                ],
                commissairesCommunaux: [
                    { name: 'Marcelin AGAYA' },
                    { name: 'Clovis RAGANISO' }
                ]
            },
            {
                name: 'Département de Ndougou (Gamba)',
                code: 'NDG',
                ville: 'Gamba',
                commissairesDepartementaux: [
                    { name: 'Antoine PANDZOU' },
                    { name: 'Claudine MOUYAMA', isWoman: true },
                    { name: 'Serges landry PANZOU' }
                ],
                commissairesCommunaux: [
                    { name: 'Flavien FLAVOR NGUIMBI' },
                    { name: 'Thierry KUIMA' },
                    { name: 'Eddy Marco MOUBAMOU' },
                    { name: 'Davy Edgar MOUSSAVOU' }
                ]
            }
        ]
    },

    // G9 - PROVINCE DU WOLEU-NTEM
    {
        id: 'G9',
        name: 'Woleu-Ntem',
        code: 'G9',
        color: 'primary-yellow',
        bgColor: 'bg-primary-yellow',
        textColor: 'text-primary-yellow',
        totalCommissaires: 97,
        totalWomen: 18,
        departements: [
            {
                name: 'Commune d\'Oyem',
                code: 'OYM',
                commissairesDepartementaux: [],
                communes: [
                    {
                        name: 'Oyem',
                        arrondissements: [
                            {
                                name: '1er arrondissement',
                                commissaires: [
                                    { name: 'Serge ABESSOLO MBA' },
                                    { name: 'Eric OBIANG OBAME' },
                                    { name: 'Clémence ELLA ASSA', isWoman: true },
                                    { name: 'Julia Melaide NZEMO', isWoman: true },
                                    { name: 'Bruno NGUEMA ONDO' }
                                ]
                            },
                            {
                                name: '2e arrondissement',
                                commissaires: [
                                    { name: 'Louise Pierrette MVONO', isWoman: true },
                                    { name: 'Arsène MINTSA MEYE' },
                                    { name: 'Joel OBIANG BIBANG' },
                                    { name: 'Caroline MIMBOUI', isWoman: true },
                                    { name: 'Carine OBONE ZOGO Epse NZAOU', isWoman: true }
                                ]
                            }
                        ],
                        cantons: [
                            {
                                name: 'Canton de BISSOCK',
                                commissaires: [
                                    { name: 'Hugues MFA NGUEMA' },
                                    { name: 'Francois Auguste AKOMEZOGUE' },
                                    { name: 'Blanche ABEGHE OBAME', isWoman: true },
                                    { name: 'Anges ESSONO ABAGA' }
                                ]
                            },
                            {
                                name: 'Canton de KYE',
                                commissaires: [
                                    { name: 'Cléopatre EDOU NGUEMA', isWoman: true },
                                    { name: 'Pamphile MEZUI M\'OBAME' },
                                    { name: 'Pr. Mathurin OVONO EBE' },
                                    { name: 'Gervais NDONG OBIANG' }
                                ]
                            },
                            {
                                name: 'Canton de WOLEU',
                                commissaires: [
                                    { name: 'Christian MBOULOU MVE' },
                                    { name: 'Martial ALLOGO' },
                                    { name: 'Pr Joséphine OKOME BEKA', isWoman: true },
                                    { name: 'Rémi NZOGO ESSONO' },
                                    { name: 'Anatole OVE MFAME' }
                                ]
                            },
                            {
                                name: 'Canton de ELELEM',
                                commissaires: [
                                    { name: 'Sylvain OLLAME NDONG' },
                                    { name: 'Martin ELLA' },
                                    { name: 'Lesiane BISSEGUE', isWoman: true },
                                    { name: 'Etienne MINTSA' }
                                ]
                            },
                            {
                                name: 'Canton de NYE',
                                commissaires: [
                                    { name: 'Patrice Herman ASSOUMOU OVONO' },
                                    { name: 'Annicet ENGO' },
                                    { name: 'Pierre Simon OBAME' },
                                    { name: 'Fernandez ONA' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Département du Ntem (Bitam)',
                code: 'NTM',
                ville: 'Bitam',
                commissairesDepartementaux: [
                    { name: 'Pascal Boileau OBIANG NDONG' },
                    { name: 'Aboubacar ALIOU' },
                    { name: 'Dieudonné NDEMEZO' },
                    { name: '4O OBIANG' },
                    { name: 'Véréna MENGUE', isWoman: true }
                ],
                cantons: [
                    {
                        name: 'Canton KOUM-KESS MBOA',
                        commissaires: [
                            { name: 'Abdon ONDO ASSOUMOU' },
                            { name: 'Darlene NTONGONE AKOUE', isWoman: true },
                            { name: 'Fidèle TOMO' },
                            { name: 'Timo Léon OVONO EDOU' }
                        ]
                    },
                    {
                        name: 'Canton NTEM 1: MVEZE',
                        commissaires: [
                            { name: 'Pr. Médard MENGUE BIDZO' },
                            { name: 'Michele ONDO ASSOUMOU', isWoman: true },
                            { name: 'Jean Jacques ESSONO NGUEMA' },
                            { name: 'Eusebe NGUEMA EDZO' }
                        ]
                    },
                    {
                        name: 'Canton NTEM 2: EKORETE',
                        commissaires: [
                            { name: 'Joel ONDO ELLA' },
                            { name: 'Rudy MINKO' },
                            { name: 'Pr. Gabriel ZOMO YEBE' }
                        ]
                    }
                ]
            },
            {
                name: 'Département du Haut-Ntem (Minvoul)',
                code: 'HNT',
                ville: 'Minvoul',
                commissairesDepartementaux: [
                    { name: 'Eric ESSONO MEZUI' },
                    { name: 'Patrick AYANG MBOME NZENG' },
                    { name: 'Prosper EVINA ABESSOLO' },
                    { name: 'Kevin NSA' }
                ],
                commissairesCommunaux: [
                    { name: 'Alexis N\'NANG NTSEME' },
                    { name: 'Kevin OTSAGHE' },
                    { name: 'Kevin OTSAGHE' },
                    { name: 'Olivier MEBIAME ASSAME' }
                ]
            },
            {
                name: 'Département de l\'Okano (Mitzic)',
                code: 'OKN',
                ville: 'Mitzic',
                commissairesDepartementaux: [
                    { name: 'Paule ATSAME BEKALE', isWoman: true },
                    { name: 'Edith ADA ESSONO Epse EVA', isWoman: true },
                    { name: 'Pr Cyriaque AKOMOZOGO' },
                    { name: 'Nicaise BIYOGHE BI NZUE' },
                    { name: 'Armelle NTSAME', isWoman: true },
                    { name: 'Franck Bernard MVE' }
                ],
                commissairesCommunaux: [
                    { name: 'Françoise ASSENGONE OBAME', isWoman: true },
                    { name: 'Dr Daniel OBAME ONDO' },
                    { name: 'Constant BEKALE BE NZE' },
                    { name: 'Annicet MEGNE' },
                    { name: 'Placide MBENG' },
                    { name: 'Edna ADA MVONE', isWoman: true },
                    { name: 'Norbert NKOGHE' }
                ]
            },
            {
                name: 'Département du Haut-Como (Medouneu)',
                code: 'HCM',
                ville: 'Medouneu',
                commissairesDepartementaux: [
                    { name: 'Christrian EBE' },
                    { name: 'Albert NDOUME EDOU' },
                    { name: 'Christian EBE' },
                    { name: 'Henri Claude OBAME' },
                    { name: 'Benoît NKOGHE SIMA' },
                    { name: 'Hyacinthe ANGOUE NTOUTOUME' }
                ]
            }
        ]
    }
];

// ==========================================
// FONCTIONS UTILITAIRES
// ==========================================

/**
 * Calcule le nombre total de commissaires dans toutes les provinces
 */
export const getTotalCommissaires = (): number => {
    return COMMISSARIAT_POLITIQUE_DATA.reduce((total, province) => total + province.totalCommissaires, 0);
};

/**
 * Calcule le nombre total de femmes commissaires
 */
export const getTotalWomen = (): number => {
    return COMMISSARIAT_POLITIQUE_DATA.reduce((total, province) => total + province.totalWomen, 0);
};

/**
 * Récupère une province par son ID
 */
export const getProvinceById = (id: string): ProvinceCommissariat | null => {
    return COMMISSARIAT_POLITIQUE_DATA.find(p => p.id === id) || null;
};

/**
 * Recherche des commissaires par nom
 */
export const searchCommissaires = (searchTerm: string): { province: string; departement: string; name: string; isWoman?: boolean }[] => {
    const results: { province: string; departement: string; name: string; isWoman?: boolean }[] = [];
    const term = searchTerm.toLowerCase();

    COMMISSARIAT_POLITIQUE_DATA.forEach(province => {
        province.departements.forEach(departement => {
            // Commissaires départementaux
            departement.commissairesDepartementaux.forEach(commissaire => {
                if (commissaire.name.toLowerCase().includes(term)) {
                    results.push({
                        province: province.name,
                        departement: departement.name,
                        name: commissaire.name,
                        isWoman: commissaire.isWoman
                    });
                }
            });

            // Commissaires communaux directs
            departement.commissairesCommunaux?.forEach(commissaire => {
                if (commissaire.name.toLowerCase().includes(term)) {
                    results.push({
                        province: province.name,
                        departement: departement.name,
                        name: commissaire.name,
                        isWoman: commissaire.isWoman
                    });
                }
            });

            // Commissaires dans les communes/arrondissements/cantons
            departement.communes?.forEach(commune => {
                commune.arrondissements?.forEach(arrondissement => {
                    arrondissement.commissaires.forEach(commissaire => {
                        if (commissaire.name.toLowerCase().includes(term)) {
                            results.push({
                                province: province.name,
                                departement: `${departement.name} - ${commune.name} - ${arrondissement.name}`,
                                name: commissaire.name,
                                isWoman: commissaire.isWoman
                            });
                        }
                    });
                });

                commune.cantons?.forEach(canton => {
                    canton.commissaires.forEach(commissaire => {
                        if (commissaire.name.toLowerCase().includes(term)) {
                            results.push({
                                province: province.name,
                                departement: `${departement.name} - ${commune.name} - ${canton.name}`,
                                name: commissaire.name,
                                isWoman: commissaire.isWoman
                            });
                        }
                    });
                });

                commune.commissaires?.forEach(commissaire => {
                    if (commissaire.name.toLowerCase().includes(term)) {
                        results.push({
                            province: province.name,
                            departement: `${departement.name} - ${commune.name}`,
                            name: commissaire.name,
                            isWoman: commissaire.isWoman
                        });
                    }
                });
            });

            // Commissaires dans les cantons directs
            departement.cantons?.forEach(canton => {
                canton.commissaires.forEach(commissaire => {
                    if (commissaire.name.toLowerCase().includes(term)) {
                        results.push({
                            province: province.name,
                            departement: `${departement.name} - ${canton.name}`,
                            name: commissaire.name,
                            isWoman: commissaire.isWoman
                        });
                    }
                });
            });
        });
    });

    return results;
};

/**
 * Filtre les provinces par terme de recherche
 */
export const filterProvinces = (searchTerm: string): ProvinceCommissariat[] => {
    if (!searchTerm.trim()) return COMMISSARIAT_POLITIQUE_DATA;

    const term = searchTerm.toLowerCase();
    return COMMISSARIAT_POLITIQUE_DATA.filter(province =>
        province.name.toLowerCase().includes(term) ||
        province.code.toLowerCase().includes(term) ||
        province.departements.some(dept => dept.name.toLowerCase().includes(term))
    );
};

/**
 * Récupère les statistiques générales du commissariat
 */
export const getCommissariatStats = () => {
    const totalCommissaires = getTotalCommissaires();
    const totalWomen = getTotalWomen();
    const totalMen = totalCommissaires - totalWomen;

    return {
        totalCommissaires,
        totalWomen,
        totalMen,
        womenPercentage: Math.round((totalWomen / totalCommissaires) * 100),
        menPercentage: Math.round((totalMen / totalCommissaires) * 100),
        totalProvinces: COMMISSARIAT_POLITIQUE_DATA.length,
        totalDepartements: COMMISSARIAT_POLITIQUE_DATA.reduce((total, province) =>
            total + province.departements.length, 0
        )
    };
};
